<script lang="ts" setup>
import { useLogInOut } from '@exchange/libs/auth/ui/src';
import useMQBreakpoints from '@exchange/libs/composables/shared/src/lib/useMQBreakpoints';

defineProps({
  showSpinner: { type: Boolean, default: false },
});

const { isXS } = useMQBreakpoints();
const { signup, login } = useLogInOut();
</script>

<template>
  <div class="logged-out-overlay">
    <template v-if="!showSpinner">
      <x-button
        class="logged-out-overlay__login"
        variant="primary"
        :text="$t('modules.login.navBarLoginButtonText')"
        @click="login"
      />
      <x-button
        class="logged-out-overlay__signup"
        variant="outline"
        :text="$t('modules.login.formOverlaySignupButtonText')"
        @click="signup"
      />
    </template>
    <template v-else>
      <ot-spinner class="logged-out-overlay__spinner" />
    </template>
  </div>
</template>

<style lang="scss">
.logged-out-overlay {
  position: absolute;
  z-index: var(--logged-out-overlay-z-index);
  top: 0;
  left: 0;
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: rgb(var(--v-theme-overlay-2));
  opacity: 0;
  transition: opacity 200ms ease-out;

  &:hover {
    opacity: 1;
  }

  &__login {
    width: calc(70% - 20px);
    margin-right: 10px;
    margin-left: 10px;
  }

  &__signup {
    width: calc(70% - 20px);
    margin-top: 15px;
    color: rgb(var(--v-theme-text-primary));

    &:hover {
      color: rgb(var(--v-theme-primary));
    }
  }

  &__spinner {
    width: 60px;
    color: rgb(var(--v-theme-text-primary));
  }

  .touch-screen & {
    opacity: 1;
  }
}
</style>
